import _extends from "@babel/runtime/helpers/extends";
/**
 * A button that renders a `rightIcon` when `active`.
 * Might add some additional styles here.
 */
import React from 'react';
import Button from './Button';
function SelectableButton({
  active,
  ...rest
}) {
  return /*#__PURE__*/React.createElement(Button, _extends({
    active: active,
    rightIcon: active ? 'tick' : undefined
  }, rest));
}
SelectableButton.defaultProps = {
  alignText: 'left',
  p: '12px'
};
export default SelectableButton;